import { h, Fragment } from 'preact';
import { useHotelsQuery } from 'common/api/hotels-api';
import { TYPES } from 'common/constants';
import Listing from 'common/components/listing';
import SkeletonListing from 'common/components/listing/skeleton-listing';

export default function HotelListing({ data }) {
    // if there's NO playlist it is Video - Hotels Listing
    const playlist = data.playlist ? JSON.parse( data.playlist ) : false;
    const hotels = playlist ? playlist.map( item => item.hotel ) : data.hotels.replace(' ', '');

    if (!hotels) {
        return '';
    }

    const { data: playlistData, isSuccess: playlistDataSuccess, isLoading } = useHotelsQuery( { hotels } );
    
    if(isLoading) {
        return <SkeletonListing isLoading={isLoading} />
    }

    return (
        <>
            {(playlistDataSuccess && playlistData) && (
                <Listing data={{...data, playlist, items: playlistData, type: TYPES.hotels }} />
            )}
        </>
    );
};